var exports = {
  "v_": "DiscoveryNavbar.module__navbar___NmdpWm",
  "Bx": "DiscoveryNavbar.module__leftSection___NmdpWm",
  "LY": "DiscoveryNavbar.module__leftSurface___NmdpWm",
  "Gv": "DiscoveryNavbar.module__backButton___NmdpWm",
  "dc": "DiscoveryNavbar.module__searchTitle___NmdpWm",
  "$L": "DiscoveryNavbar.module__categoryTabs___NmdpWm",
  "Wu": "DiscoveryNavbar.module__categoryTab___NmdpWm",
  "KB": "DiscoveryNavbar.module__categoryTabActive___NmdpWm" + " " + "DiscoveryNavbar.module__categoryTab___NmdpWm",
  "uk": "DiscoveryNavbar.module__searchArea___NmdpWm",
  "rm": "DiscoveryNavbar.module__searchForm___NmdpWm",
  "qc": "DiscoveryNavbar.module__searchIcon___NmdpWm",
  "Rt": "DiscoveryNavbar.module__searchInput___NmdpWm",
};

module.exports = exports;
